import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=c5e958ae&scoped=true&"
import script from "./clientDetail.vue?vue&type=script&lang=js&"
export * from "./clientDetail.vue?vue&type=script&lang=js&"
import style0 from "./clientDetail.vue?vue&type=style&index=0&id=c5e958ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e958ae",
  null
  
)

export default component.exports